import Login from '@/components/Login'
import Users from '@/components/Users'
import Home from '@/components/Home'
import Settings from '@/components/Settings'
import Orders from '@/components/Orders'
import Materials from '@/components/Materials'
import ManualOrder from '@/components/ManualOrder'
import ManualOrderEdit from '@/components/orders/ManualEdit'
import OrderView from '@/components/orders/View'
import OrderEdit from '@/components/orders/Edit'
import OrderCreate from '@/components/orders/Create'
import ElevationCreate from '@/components/orders/ElevationCreate'
import ComplementaryMaterials from '@/components/ComplementaryMaterials'
import MarketingMaterials from '@/components/MarketingMaterials'
import ElevationEdit from '@/components/orders/ElevationEdit.vue'


export default [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            auth: false
        }
    },
    {
        path: '/users',
        name: 'Users',
        component: Users,
        meta: {
            auth: {
                roles: 'admin',
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: '/403'
            }
        }
    },
    {
        path: '/settings',
        name: 'Settings',
        component: Settings,
        meta: {
            auth: {
                roles: ['admin', 'partner'],
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: '/403'
            }
        }
    },
    {
        path: '/materials',
        name: 'Materials',
        component: Materials,
        meta: {
            auth: {
                roles: 'admin',
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: '/403'
            }
        }
    },
    {
        path: '/complementary',
        name: 'ComplementaryMaterials',
        component: ComplementaryMaterials,
        meta: {
            auth: {
                roles: 'admin',
                redirect: {
                    name: 'login'
                },
                forbiddenRedirect: '/403'
            }
        }
    },
    {
        path: '/marketing-materials',
        name: 'MarketingMaterials',
        component: MarketingMaterials,
    },
    //Manual orders
    {
        path: '/manualOrder',
        name: 'ManualOrder',
        component: ManualOrder,
        meta: {
            auth: true
        }
    },
    {
        path: '/manualOrder/:id/edit',
        name: 'ManualOrderEdit',
        component: ManualOrderEdit,
        meta: {
            auth: true,
            type: null
        }
    },
    ////
    {
        path: '/orders/:id',
        name: 'Order View',
        component: OrderView,
        meta: {
            auth: true
        }
    },
    {
        path: '/configurator',
        name: 'Configurator',
        component: OrderCreate,
        meta: {
            auth: true,
            type: 'terrace'
        }
    },
    {
        path: '/orders/:id/edit',
        name: 'Order Edit',
        component: OrderEdit,
        meta: {
            auth: true
        }
    },
    {
        path: '/elevation-config',
        name: 'Elevation',
        component: ElevationCreate,
        meta: {
            auth: true,
            type: 'elevation'
        }
    },
    {
        path: '/elevation-config/:id/edit',
        name: 'ElevationEdit',
        component: ElevationEdit,
        meta: {
            auth: true,
            type: 'elevation'
        }
    },
    {
        path: '/orders',
        name: 'Orders',
        component: Orders,
        meta: {
            auth: true,
            type: 'reserved'
        }
    },
    {
        path: '/offers',
        name: 'Offers',
        component: Orders,
        meta: {
            auth: true,
            type: 'new'
        }
    },
    {
        path: '/sent',
        name: 'Sent',
        component: Orders,
        meta: {
            auth: true,
            type: 'realized'
        }
    },


]
